import { render } from "./menuComponent.vue?vue&type=template&id=8327c7c2"
import script from "./menuComponent.vue?vue&type=script&lang=js"
export * from "./menuComponent.vue?vue&type=script&lang=js"

import "./menuComponent.vue?vue&type=style&index=0&id=8327c7c2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__